'use strict';
var util = angular.module('gymsystem.util');
util.directive('adjusttrainingcardprice', ['$rootScope', '$modal', 'server', 'util', 'confirm', function ($rootScope, $modal, server, util, confirm) {
        return {
            restrict: 'E',
            template: '<customertable config="config" />',
            scope: {
                s: '=settings'
            },
            link: function ($scope) {
                var statuses = [];
                var getStatuses = function (field) {
                    if (!field.value) {
                        return [];
                    }
                    return _.pluck(field.value, 'id').join(',');
                };
                var resetPrices = function () {
                    var items = $scope.config.control.getFilteredItems();
                    var text = util.t('You are about to update the prices of {0} training cards to their original price. Do you want to continue?').format(items.length);
                    confirm.show(text, { ladda: true }).then(function (resolve) {
                        var ids = _.uniq(_.pluck(items, 'id'));
                        server.post('/api/trainingcard/unbound/resetprice', ids).then(function () {
                            reload();
                            resolve();
                        });
                    });
                };
                var sendMailing = function () {
                    var items = $scope.config.control.getFilteredItems();
                    var recipients = _.uniq(_.pluck(items, 'user'), function (u) { return u.id; });
                    $scope.pubsub.publish('newmailingdata', {
                        isNewsOrAdvertising: false,
                        sendOption: 'mail',
                        receivers: recipients,
                        options: { 'callCloseOnSuccess': true, 'modalMode': false }
                    });
                    $modal.open({
                        templateUrl: 'views/mailingnew.html',
                        windowClass: 'huge-modal-window',
                        controller: 'NewMailingCtrl'
                    });
                };
                var trainingcards = [];
                var transform = function (tc) {
                    tc = $rootScope.transformTrainingCard(tc);
                    tc.user = $rootScope.getMember(tc.user_id);
                    return tc;
                };
                var reload = function () {
                    var buttonField = _.findWhere($scope.config.filter, { name: 'reload' });
                    buttonField.loading = true;
                    var fromDate = _.findWhere($scope.config.filter, { name: 'fromDate' }).value;
                    var toDate = _.findWhere($scope.config.filter, { name: 'toDate' }).value;
                    var args = {
                        fromDate: fromDate && fromDate.dateTime(),
                        toDate: toDate && toDate.dateTime(),
                        statuses: _.pluck(_.findWhere($scope.config.filter, { name: 'statuses' }).value, 'id')
                    };
                    server.get('/api/trainingcard/unbound/changed/get', args).then(function (cards) {
                        angular.forEach(cards, transform);
                        trainingcards = cards;
                        buttonField.loading = false;
                    });
                };
                var getExcel = function () {
                    $scope.config.control.exportTo('excel').then(function (blob) {
                        util.download('customers.xlsx', null, null, blob);
                    });
                };
                $scope.config = {
                    getItems: function () {
                        return trainingcards;
                    },
                    getTitle: function () {
                        return 'Customers';
                    },
                    filter: [
                        { name: 'fromDate', title: 'From', type: 'date', required: false },
                        { name: 'toDate', title: 'To', type: 'date', required: false, value: new Date() },
                        { name: 'statuses', title: 'Statuses', type: 'multiselect', required: false, options: function () { return statuses; }, visible: function () { return $rootScope.hasPermission('Admin') && statuses.length; }, useId: true, getValue: getStatuses },
                        { name: 'reload', buttonTitle: 'Get cards', type: 'button', buttonClass: 'btn-success', click: reload }
                    ],
                    rowClick: function (tc) {
                        $rootScope.gotoCustomer(tc.user);
                    },
                    searchButtons: [
                        { title: 'Update prices', onClick: resetPrices, disabled: function () { return $scope.config.control.getNumberOfFilteredItems() < 1; } },
                        { title: 'Send mail', onClick: sendMailing, visible: function () { return $rootScope.hasPermission('Send mail'); } },
                        { title: 'Download as Excel', onClick: getExcel }
                    ],
                    columns: [
                        { field: 'user.name', title: util.t('Customer') + ' > ' + util.t('Name') },
                        { field: 'user.mail', title: 'E-mail' },
                        { field: 'cardtype.name', title: util.t('Training card type') + ' > ' + util.t('Name') },
                        { field: 'boundToDate', title: 'Bound to', format: 'date' },
                        { field: 'price', title: 'Price', format: 'price' }
                    ]
                };
                (function () {
                    if (!$rootScope.hasPermission('Admin')) {
                        return;
                    }
                    server.get('/api/member/status/get/all').then(function (d) { return (statuses = d); });
                })();
            }
        };
    }]);
